export const lockScroll = () => {
  document.body.classList.add('--locked')
}

export const unlockScroll = () => {
  document.body.classList.remove('--locked')
}
